export default "__VITE_ASSET__Bn3u2Tky__"